import * as React from 'react';
import styles from '@/styles/ComparisonSection.module.scss';
import {Competitor} from "@/content/comparisons";

const ComparisonSection: React.FC<{ competitors: Competitor[] }> = ({competitors}) => (
  <section className={styles.comparison}>
    <h2 className="text-center text-5xl mb-12">Compare</h2>
    <div className="mx-auto flex flex-col md:flex-row justify-center space-y-10 md:space-y-0 md:space-x-14">
      {competitors.map((competitor, index) => (
        <div key={competitor.slug} className="w-full md:w-1/2">
          <h3 className="text-4xl text-center mb-3">{competitor.name}</h3>
          <img className={styles.productImage} src={competitor.image} alt={`${competitor.name} product image`}/>
          <p className="text-2xl text-justify">{competitor.description}</p>
        </div>
      ))}
    </div>

  </section>
);

export default ComparisonSection;
